export default __webpack_public_path__ + "static/media/playstation@2x.245371cb.jpg";